import Axios from 'axios'
import strings from '@/strings'

export default {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getApplicationSettings() {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/configurations`)
  },
  addApplicationSetting(setting) {
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/configurations`, setting)
  },
  updateApplicationSetting(setting) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/configurations/${setting.id}`, setting)
  }
}